import IconTooltip from "@metacrm/metacrm-material-ui/dist/IconTooltip";
import { Box } from "@mui/material";
import axios from "axios";
import { apiUrl } from "features/configure";
import { StyledThumbIcon } from "features/metadesk/ticket/Chat.styles";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import useGetPagePermission from "hooks/useGetPagePermission";
import useNavigateEntity from "hooks/useNavigateEntity";
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router";
import { useIntl } from "react-intl";
import { formatDate } from "features/helpers/utils";
import TrainingEditModal from "./TrainingEditModal";
import useGetTrainingData from "./useGetTrainingData";

export default function ResponseThumb({ data, refresh }) {
  const { formatMessage } = useIntl();
  const [thumb, setThumb] = useState();
  const [editInfo, setEditInfo] = useState(null);
  const [entityName] = useOutletContext();
  const {
    adminFeedback,
    userFeedback,
    adminFeedbackBy,
    adminFeedbackCreated,
    userFeedbackCreated,
    originalResponse,
    testGround,
    ticket,
  } = data;

  const { navigateEntity } = useNavigateEntity();
  const dispatchSnackbar = useDispatchSnackbar();
  const { setCanUpdateResponse } = useGetTrainingData();

  useEffect(() => {
    if (adminFeedback) {
      return setThumb(adminFeedback);
    }
    if (userFeedback) {
      return setThumb(userFeedback);
    }
  }, [data]);

  async function handleThumbUp() {
    if (thumb === "thumbUp") return;
    try {
      await axios.post(`${apiUrl}/api/trainingArea/${entityName}/messages`, {
        messageId: data._id,
        adminFeedback: "thumbUp",
      });
      setThumb("thumbUp");
      refresh();
    } catch (err) {
      dispatchSnackbar({ err });
    }
  }
  async function handleThumbDown() {
    if (thumb === "thumbDown") return;
    await axios.post(`${apiUrl}/api/trainingArea/${entityName}/messages`, {
      messageId: data._id,
      adminFeedback: "thumbDown",
    });
    setThumb("thumbDown");
    setEditInfo(data);
  }

  const pagePermission = useGetPagePermission();
  const { canEdit } = pagePermission("aiManagement");

  const getTooltipText = (type) => {
    if (thumb === type) {
      if (adminFeedback === type) {
        return `Feedback from ${adminFeedbackBy?.name} on ${formatDate(
          adminFeedbackCreated
        )}`;
      }
      if (userFeedback === type) {
        return `Feedback from User on ${formatDate(userFeedbackCreated)}`;
      }
    }
    return formatMessage({
      id:
        type === "thumbUp"
          ? "trainingArea.feedback.good"
          : "trainingArea.feedback.bad",
    });
  };

  return (
    <>
      <Box mb="10px" color={thumb === "thumbDown" ? "#FC5555" : "#222"}>
        {originalResponse}
      </Box>
      {canEdit && (
        <Box className="item-flex" gap="0 12px">
          <IconTooltip
            icon={
              <StyledThumbIcon
                className="meta-crm-icon-ic_thumb-up font-size-16"
                active={thumb === "thumbUp"}
                onClick={handleThumbUp}
              />
            }
            content={getTooltipText("thumbUp")}
          />

          <IconTooltip
            icon={
              <StyledThumbIcon
                className="meta-crm-icon-ic_thumb-down font-size-16"
                active={thumb === "thumbDown"}
                onClick={handleThumbDown}
              />
            }
            content={getTooltipText("thumbDown")}
          />
          {testGround ? (
            <IconTooltip
              icon={
                <StyledThumbIcon
                  className="meta-crm-icon-ic_search-2 font-size-14"
                  disabled={testGround}
                />
              }
              content={formatMessage({
                id: "trainingArea.testGround.hoverMessage",
              })}
            />
          ) : (
            <IconTooltip
              icon={
                <StyledThumbIcon
                  className="meta-crm-icon-ic_search-2 font-size-14"
                  onClick={() =>
                    navigateEntity(`/service/ticket/new?ticketId=${ticket}`)
                  }
                />
              }
              content={formatMessage({
                id: "trainingArea.action.viewOriginal",
              })}
            />
          )}
        </Box>
      )}
      {editInfo && (
        <TrainingEditModal
          editInfo={editInfo}
          onClose={() => {
            setEditInfo(null);
            refresh();
          }}
          refresh={refresh}
          setCanUpdateResponse={setCanUpdateResponse}
        />
      )}
    </>
  );
}
